import { createUseHttpCallback } from './useHttpCallback'

export { type Callback, axiosWithRetry } from './useHttpCallback'

const usePostCallback = createUseHttpCallback('post', false)

export const usePostCallbackWithRetry = createUseHttpCallback('post', true)

export default usePostCallback
